var _ = require('underscore');
var AccordionFormWidget = require('./../widget/accordion/AccordionFormWidget');
var patientSettingsSecurityQuestionsAccordionFormTemplate = require('./patientSettingsSecurityQuestionsAccordionFormTemplate.hbs');
var PatientSettingsSecurityQuestionsFormModel = require('./PatientSettingsSecurityQuestionsFormModel');
var enumerationListService = require('./../enumeration/enumerationListService');
var patientSettingsService = require('./patientSettingsService');

var SECURITY_QUESTIONS_OPTIONS_LIST = 'securityQuestionsOptionList';
var MS_TO_SHOW_SAVE_SUCCESS = 10 * 1000;

/**
 * Form View for Patient Portal Settings Security Questions Accordion
 *
 * @class PatientSettingsSecurityQuestionsAccordionFormView
 * @extends AccordionFormWidget
 */
module.exports = AccordionFormWidget.extend({
  template: patientSettingsSecurityQuestionsAccordionFormTemplate,

  prepareFields: _.extend({}, AccordionFormWidget.prototype.prepareFields, {
    securityQuestionsOptionList: function() {
      return enumerationListService.get(SECURITY_QUESTIONS_OPTIONS_LIST);
    }
  }),

  events: _.extend({}, AccordionFormWidget.prototype.events, {
    'click [data-save-security-questions]': '_save'
  }),

  feedback: [{
//******** Security Question 1 *********
   /**
    * On keyup or blur on the securityQuestion1, validate the securityQuestion1
    * @property feedback[0] (Security Question 1 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityQuestion1' : ['keyup', 'blur', 'change']
    },
    then: function() {
      var isValid = this.model.isValid('securityQuestion1');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityQuestion1Error'
  }, {
   /**
    * On keyup or blur on the securityQuestion1, validate the securityQuestion1
    * @property feedback[1] (Security Question 1 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityQuestion1' : ['keyup', 'blur', 'change']
    },
    then: function() {
      return this._thenAddClassIfInvalid('securityQuestion1', 'brec-form__input--error');
    },
    to: 'securityQuestion1'
  }, {
     /**
    * On keyup or blur on the securityQuestion1, validate if securityQuestion2 is unique
    * @property feedback[2] (Security Question 2 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityQuestion1' : ['keyup', 'blur', 'change']
    },
    then: function() {
      var errors = this.model.preValidate('securityQuestion2');
      if (errors.key === 'error.unique') {
        var errorText = this._thenFormatFeedback(this.model.preValidate('securityQuestion2'), {
          'error.unique' : 'patient.settings.securityQuestions.question.error.unique'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityQuestion2Error'
  }, {
   /**
    * On keyup or blur on the securityQuestion1, validate if securityQuestion2 is unique
    * @property feedback[3] (Security Question 2 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityQuestion1' : ['keyup', 'blur', 'change']
    },
    then: function() {
      var errors = this.model.preValidate('securityQuestion2');
      if (errors.key === 'error.unique') {
        return {
          addClass: 'brec-form__input--error'
        };
      } else {
        return {
          removeClass: 'brec-form__input--error'
        };
      }
    },
    to: 'securityQuestion2'
  }, {
   //******** Security Answer 1 *********
   /**
    * On keyup or blur on the securityAnswer1, validate the securityAnswer1
    * @property feedback[4] (Security Answer 1 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityAnswer1' : ['keyup', 'blur', 'change']
    },
    then: function() {
      var isValid = this.model.isValid('securityAnswer1');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityAnswer1Error'
  }, {
    /**
    * On keyup or blur on the securityAnswer1, validate the securityAnswer1
    * @property feedback[5] (Security Answer 1 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityAnswer1' : ['keyup', 'blur', 'change']
    },
    then: function() {
      return this._thenAddClassIfInvalid('securityAnswer1', 'brec-form__input--error');
    },
    to: 'securityAnswer1'
  }, {
   //******** Security Question 2 *********
   /**
    * On keyup or blur on the securityQuestion2, validate the securityQuestion2
    * @property feedback[6] (Security Question 2 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityQuestion2' : ['keyup', 'blur', 'change']
    },
    then: function() {
      var isValid = this.model.isValid('securityQuestion2');
      if (!isValid) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('securityQuestion2'), {
          'required.failed': 'patient.settings.securityQuestions.question.error.required',
          'error.unique' : 'patient.settings.securityQuestions.question.error.unique'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityQuestion2Error'
  }, {
    /**
    * On keyup or blur on the securityQuestion2, validate the securityQuestion2
    * @property feedback[7] (Security Question 2 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityQuestion2' : ['keyup', 'blur', 'change']
    },
    then: function() {
      return this._thenAddClassIfInvalid('securityQuestion2', 'brec-form__input--error');
    },
    to: 'securityQuestion2'
  }, {
   //******** Security Answer 2 *********
   /**
    * On keyup or blur on the securityAnswer2, validate the securityAnswer2
    * @property feedback[8] (Security Answer 2 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityAnswer2' : ['keyup', 'blur', 'change']
    },
    then: function() {
      var isValid = this.model.isValid('securityAnswer2');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityAnswer2Error'
  }, {
    /**
    * On keyup or blur on the securityAnswer2, validate the securityAnswer2
    * @property feedback[9] (Security Answer 2 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityAnswer2' : ['keyup', 'blur', 'change']
    },
    then: function() {
      return this._thenAddClassIfInvalid('securityAnswer2', 'brec-form__input--error');
    },
    to: 'securityAnswer2'
  }, {
   /**
    * On model change, if the model has validation errors, disable the save button.
    * @property feedback[10] (Save Button) {When/Then Feedback}
    */
    when: {
      listenTo: [
        {
          object: 'model',
          events: 'change'
        },
      ]
    },
    then: function() {
      var errors = this.model.validate();
      errors = _.keys(errors);
      var noErrors = errors.length === 0;
      if (noErrors) {
        return {
          removeClass: 'brec-btn--disabled',
          removeAttr: ['disabled']
        };
      } else {
        return {
          addClass: 'brec-btn--disabled',
          attr: ['disabled', 'disabled']
        };
      }
    },
    to: 'saveBtn'
  }, {
   /**
    * On submitting, disable the save button.
    * @property feedback[11] (Save Button) {When/Then Feedback}
    */
    when: {
      'on': ['submitting']
    },
    then: function() {
      return {
        addClass: 'brec-btn--disabled',
        attr: ['disabled', 'disabled']
      };
    },
    to: 'saveBtn'
  }],

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient to render the data for.
   * @override
   */
  initialize: function(options) {
    AccordionFormWidget.prototype.initialize.apply(this, arguments);
    _.bindAll(this, '_setSavedSuccess', '_hideSaveSuccess', '_processErrors');
    this.model = new PatientSettingsSecurityQuestionsFormModel();
    this.patientVecnaId = options.patientVecnaId;
    this.listenTo(this.viewState, 'change:submitting change:saved change:errors', this.render);
    this._setupSecurityQuestions();
  },

  /**
   * @method _setupSecurityQuestions
   * @private
   */
  _setupSecurityQuestions: function() {
    enumerationListService.fetch(SECURITY_QUESTIONS_OPTIONS_LIST);
  },

  /**
   * Save security questions and answers
   * @method _save
   * @private
   */
  _save: function(event) {
    event.preventDefault();
    this.trigger('submitting');
    this.set('submitting', true);
    this.unset('errors');
    patientSettingsService.saveSettings(this.model, this.patientVecnaId)
      .then(this._setSavedSuccess, this._processErrors)
      .then(patientSettingsService.resetAndFetchModel, patientSettingsService.resetAndFetchModel);
  },

  /**
   * Triggers an event on portalUserModel that the new password is successfully saved
   * @method _setSavedSuccess
   * @private
   */
  _setSavedSuccess: function() {
    this.model = new PatientSettingsSecurityQuestionsFormModel();
    this.set('saved', true);
    this.set('submitting', false);
    window.clearTimeout(this._hideSuccessTimeout);
    if (MS_TO_SHOW_SAVE_SUCCESS >= 0) {
      this._hideSuccessTimeout = window.setTimeout(this._hideSaveSuccess, MS_TO_SHOW_SAVE_SUCCESS);
    }
  },

  /**
   * Unsets that the save completed successfully on the vew state.
   * @method _hideSaveSuccess
   * @private
   */
  _hideSaveSuccess: function() {
    this.unset('saved');
  },

  /**
   * Sets the passed error onto the view state. The error code maps to i18n key as defined in the template.
   * If the response contains a message key for the error,
   * that will be used instead of the mapped response status message.
   *
   * @param response {Object} HTTP response
   * @private
   * @method _processErrors
   */
  _processErrors: function(response) {
    this.set('submitting', false);
    var responseStatus = response && response.status;
    var errors = this._errorCodeMap[responseStatus];
    if (_.isFunction(errors)) {
      var errorFn = _.bind(errors, this);
      errors = errorFn(response);
    }
    errors = errors || this._errorCodeMap.default;

    if (response && response.responseJSON && !_.isEmpty(response.responseJSON.generalReasons)) {
      var generalReason = response.responseJSON.generalReasons[0];
      errors.specificReasonKey = generalReason.messageKey;
    }

    this.set('errors', errors);
  },

  /**
   * Map from error code to errors object to use.  If a function is defined then it will be
   * called in the context of this view.
   * @property _errorCodeMap
   * @type {Object}
   */
  _errorCodeMap: {
    500 : { errorCode: 'INTERNAL_ERROR' },
    default : { errorCode: 'ERROR' }
  },

  /**
   * @method _attached
   * @private
   */
  _attached: function() {
    this.listenTo(enumerationListService, 'change:' + SECURITY_QUESTIONS_OPTIONS_LIST, this.render);
  },

  /**
   * @method _detached
   * @private
   */
  _detached: function() {
    this.stopListening(enumerationListService, 'change:' + SECURITY_QUESTIONS_OPTIONS_LIST, this.render);
  }
});
